import angular from 'angular';
import PaginationComponent from './paginationRemote.component';

const paginationRemoteModule = angular.module('tinaba.common.paginationRemote', [])

.component('paginationRemote', PaginationComponent);

export default paginationRemoteModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/pagination-remote/paginationRemote.js
 **/